import React, { useState } from "react";
import { m } from "framer-motion";
import cx from "classnames";
import Icon from "@components/icon";

const accordionAnim = {
  open: {
    opacity: 1,
    height: "auto",
  },
  closed: {
    opacity: 0,
    height: 0,
  },
};

const Accordion = ({
  id,
  title,
  tooltip = false,
  isOpen = false,
  style = "default",
  isControlled = false,
  onToggle = () => {},
  className,
  children,
  value = false,
}) => {
  const [hasFocus, setHasFocus] = useState(isOpen);

  return (
    <div key={id} className={cx("accordion", className)}>
      {!isControlled && (
        <button
          onClick={() => onToggle(id, !isOpen)}
          aria-expanded={isOpen}
          aria-controls={`accordion-${id}`}
          className={cx(
            "accordion--toggle type--h-sm flex w-full text-left items-center",
            "p-5",
            "mb-2",
            "rounded-[3px]",
            {
              "border-t px-0 uppercase mb-0 rounded-t-none":
                style == "mobile-alt",
              "bg-white": style == "default",
              "is-open": isOpen,
              "bg-yellow": isOpen && style !== "mobile-alt",
            }
          )}
        >
          {title}
          <div
            className={cx(
              "accordion--icon",
              "inline-flex",
              "items-center",
              "transition-transform",
              "md:ml-auto",
              "relative",
              "top-[-2px]",
              "w-[20px]",
              "h-[20px]",
              "md:w-[28px]",
              "md:h-[28px]",
              {
                "rotate-45": isOpen,
                "ml-auto": !value,
              }
            )}
          >
            <Icon
              name="AccordionIcon"
              id={`-${id}`}
              viewBox="0 0 28 28"
              color="#000000"
              className={cx("w-[28px]")}
            />
          </div>
        </button>
      )}

      <m.div
        id={`accordion-${id}`}
        className="accordion--content"
        initial={isOpen ? "open" : "closed"}
        animate={isOpen ? "open" : "closed"}
        variants={accordionAnim}
        transition={{ duration: 0.5, ease: [0.19, 1.0, 0.22, 1.0] }}
        onAnimationComplete={(v) => setHasFocus(v === "open")}
      >
        <div
          className={cx(
            "accordion--inner",
            "type--base",
            "pt-1",
            "pb-5",
            "md:pb-3"
          )}
          hidden={!isOpen && !hasFocus}
        >
          <div>{children}</div>
        </div>
      </m.div>
    </div>
  );
};

export default Accordion;
